import { render } from "./warehouse-items.vue?vue&type=template&id=5305bd04&scoped=true"
import script from "./warehouse-items.vue?vue&type=script&lang=js"
export * from "./warehouse-items.vue?vue&type=script&lang=js"

import "./warehouse-items.vue?vue&type=style&index=0&id=5305bd04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5305bd04"]])

export default __exports__